<template>
  <div>
    <ViewTemplateReportList :panel="panel" :reports="reports" />
  </div>
</template>

<script>
import ViewTemplateReportList from "@nixweb/nixloc-ui/src/component/template/ViewTemplateReportList";

export default {
  name: "ReportAdmView",
  components: { ViewTemplateReportList },
  data() {
    return {
      panel: {
        module: "Adm",
        title: "Relatório",
        showFilter: false,
        showSearch: true,
        showButtons: false,
      },
      reports: {
        default: [
          {
            name: "Auditoria",
            description: "",
            routeName: "reportAdmAudit",
          },
        ],
        saved: [],
      },
    };
  },
};
</script>
